import { startLinkedApp } from './linkedAppSso';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRouter from './AppRouter';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil';
import { AuthProvider } from './contexts/AuthContext';
import ThemeWrapper from './ThemeWrapper';

const root = ReactDOM.createRoot(document.getElementById('root'));
startLinkedApp(() => {
root.render(
    <RecoilRoot>
      <React.StrictMode>
        <ThemeWrapper>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </ThemeWrapper>
      </React.StrictMode>
  </RecoilRoot>
);
}, '/api/auth/sso-handoff');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
